import {useRef, useEffect} from 'react';
import {throttle} from 'helpers';

export function useMutationObserver(callback: Parameters<typeof throttle>[0], options = {childList: true, attributes: true, subtree: true}) {
  const ref = useRef<HTMLElement>(null);
  useEffect(() => {
    if (ref.current) {
      callback();
      const observer = new MutationObserver(throttle(callback, 100));
      observer.observe(ref.current, options);
      return () => observer.disconnect();
    }
  }, [ref.current]);
  return ref;
}
